export const DataQueryParamWorkshopName = 'workshopName';
